<div *ngIf="media" class="message-media" [ngClass]="{ mediaLoaded: isMediaLoaded }">
  <p class="message-media_head">
    <ng-container *ngIf="media.photos > 1">{{ media.photos }} IMAGES</ng-container>
    <ng-container *ngIf="media.photos === 1">
      <div class="flex items-center">
        <stxt-svg-icon class="message-media_svg" [iconConfig]="imageSvg"></stxt-svg-icon>
        <span>IMAGE</span>
      </div>
    </ng-container>
    <span>
      <ng-container *ngIf="media.photos > 0 && media.videos > 0">•</ng-container>
      <ng-container *ngIf="media.videos > 0">{{ media.videos }} VIDEOS</ng-container>
    </span>
  </p>
  <div class="message-media_wrapper">
    <ngb-carousel
      #smallCarousel
      [showNavigationArrows]="false"
      [showNavigationIndicators]="media.photos > 1"
      (slide)="onSlide($event)"
    >
      <ng-container *ngFor="let file of media.files; index as i">
        <ng-template id="ngb-slide-{{ i }}" ngbSlide>
          <div class="picsum-img-wrapper">
            <stxt-image
              [src]="file.owned ? file.url : 'assets/d2c-images/thumbnail.png'"
              [alt]="''"
              [mediaUsage]="EImageUsage.MessageMedia"
              [tabindex]="0"
              [imageLocked]="!file.owned && media.price > 0"
              [showBackgroundImage]="true"
              [backgroundImageSrc]="file.owned ? file.url : 'assets/d2c-images/thumbnail.png'"
              (click)="togglePreview(file.owned, file)"
              (keydown.enter)="togglePreview(file.owned, file)"
            ></stxt-image>

            <ng-container *ngIf="!file.owned && media.price > 0">
              <stxt-svg-icon class="lock_svg" [iconConfig]="lockSvg"></stxt-svg-icon>
            </ng-container>
          </div>
        </ng-template>
      </ng-container>
    </ngb-carousel>
  </div>

  <stxt-button
    *ngIf="mediaOwned || media.price === 0"
    (click)="unlockImage()"
    class="unlock_btn"
    [buttonConfig]="viewBtn"
  >
    {{ viewBtn.text }}
  </stxt-button>
  <button
    class="primary-outlined-button btn-nostyle"
    *ngIf="!mediaOwned && media.price > 0"
    (click)="unlockImage()"
  >
    <img src="/assets/icons/token-badge.svg" alt="token" />
    <p>{{ unlockBtn.text }}</p>
  </button>
</div>

<ng-container *ngIf="mediaFullScreen">
  <div class="media_overlay" stxtMediaPreviewClose (overlayClick)="onOverlayClick()" tabindex="0">
    <div class="media_preview__head flex">
      <div class="flex">
        <stxt-svg-icon
          class="checkout_icon"
          [iconConfig]="closeSvg"
          (click)="togglePreview(false)"
        ></stxt-svg-icon>
      </div>

      <stxt-button
        *ngIf="mediaOwned === false && media.price > 0"
        class="unlock_preview__btn"
        [buttonConfig]="unlockBtn"
        (click)="unlockImage()"
      >
        {{ unlockBtn.text }}
        <stxt-svg-icon
          class="checkout_icon"
          [iconConfig]="tokenUnlockSvg"
          (click)="unlockImage()"
        ></stxt-svg-icon>
      </stxt-button>
    </div>
    <div
      class="media_preview__carousel"
      stxtMediaPreviewClose
      (overlayClick)="onOverlayClick()"
      tabindex="0"
    >
      <ngb-carousel
        #carousel
        [showNavigationArrows]="false"
        [showNavigationIndicators]="media.photos > 1"
      >
        <ng-container *ngFor="let file of media.files; index as i">
          <ng-template id="ngb-slide-{{ i }}" ngbSlide>
            <div
              [ngClass]="{ 'owned-media': file.owned, 'locked-media': !file.owned }"
              [style.background-image]="
                'url(' + (file.owned ? file.url : 'assets/d2c-images/stxt_thumbnail.png') + ')'
              "
              class="picsum-img-wrapper media_preview__body relative"
            >
              <div class="media_preview__image-wrapper relative">
                <img
                  [src]="file.owned ? file.url : 'assets/d2c-images/stxt_thumbnail.png'"
                  class="carousel_image preview_image relative"
                  alt="{{ i }}"
                />
                <stxt-feedback-controls
                  *ngIf="isFeedbackControlsEnabled"
                  [selectedMedia]="file"
                  class="feedback-controls-overlay"
                ></stxt-feedback-controls>
                <stxt-watermark
                  *ngIf="file.owned"
                  [config]="getWatermarkConfig()"
                  [isVisible]="true"
                ></stxt-watermark>
              </div>
            </div>
            <div *ngIf="media.photos > 1" class="media_preview__navigation absolute">
              <div
                [ngClass]="{ 'hidden-nav': i === 0 }"
                (click)="carousel.prev()"
                (keydown.arrowLeft)="carousel.prev()"
                tabindex="0"
              >
                <stxt-svg-icon [iconConfig]="leftNavigation"></stxt-svg-icon>
              </div>
              <div
                [ngClass]="{ 'hidden-nav': i === media.photos - 1 }"
                (click)="carousel.next()"
                (keydown.arrowRight)="carousel.next()"
                tabindex="0"
              >
                <stxt-svg-icon [iconConfig]="rightNavigation"></stxt-svg-icon>
              </div>
            </div>
            <div *ngIf="media.photos > 1" class="media_preview__slides">
              {{ i + 1 }} of {{ media.photos }} photos
            </div>
          </ng-template>
        </ng-container>
      </ngb-carousel>
    </div>
  </div>
</ng-container>
